<template>
    <div class="categories">
        <category-filters @categoriesUpdated="updateCategories" :selected="multipleSelection" @update-filters="onUpdateFilters" ref="filtersComponent"></category-filters>
        <div class="category-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} catégories</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
                <button @click="openEdit()" class="btn btn-outline-secondary btn-sm">Créer</button>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="categories" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Nom Speedway" sortable="custom"></el-table-column>
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom"></el-table-column>
                <el-table-column prop="activated" label="Actif" sortable="custom" width="90">
                    <template slot-scope="scope">
                        <span v-if="scope.row.activated">O</span>
                        <span v-else>N</span>
                    </template>
                </el-table-column>
                <el-table-column prop="vehiculier" label="Vehiculier" sortable="custom" width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.vehiculier">O</span>
                        <span v-else>N</span>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" fixed="right">
                    <template slot-scope="scope">
                        <a :href="'/catalog?q=category:'+scope.row.id+appendSearch" v-if="scope.row.products_count">
                            <i class="fe fe-book-open"></i> <span v-if="scope.row.search_query_count">/ {{ scope.row.search_query_count }}</span>
                        </a>
                        <template v-if="scope.row.shop_id != 1">
                            <a href="#" @click.prevent="openEdit(scope.row)" >
                                <i class="fe fe-edit"></i>
                            </a>
                            <a href="#" class="text-danger" @click.prevent="removeCategory(scope.row)" >
                                <i class="fe fe-trash"></i>
                            </a>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog @closed="closeEdit" title="Création / Modification" v-loading="modal.createEditCategory.loader" :visible.sync="modal.createEditCategory.display" width="50%">
            <el-form class="formCreateEditCategory" ref="formCreateEditCategory" :rules="rules" :model="modal.createEditCategory.form" label-position="top">
                <el-form-item prop="categories" label="Catégorie parente">
                    <el-cascader
                        class="full-width"
                        clearable
                        filterable
                        change-on-select
                        :props="{label: 'name', value: 'id'}"
                        :options="categoriesOptions"
                        v-model="modal.createEditCategory.form.categories"
                        :filter-method="filterCascader"
                    >

                    </el-cascader>
                </el-form-item>
                <el-form-item prop="name" label="Nom">
                    <el-input v-model="modal.createEditCategory.form.name"></el-input>
                </el-form-item>
                <el-form-item prop="shop_id" label="ShopId">
                    <el-input v-model="modal.createEditCategory.form.shop_id"></el-input>
                </el-form-item>
                <el-form-item prop="activated" label="Activer">
                    <el-switch v-model="modal.createEditCategory.form.activated" active-text="Oui" inactive-text="Non"></el-switch>
                </el-form-item>
                <el-form-item prop="id_comarch" label="ID Comarch">
                    <el-input v-model="modal.createEditCategory.form.id_comarch"></el-input>
                </el-form-item>
                <el-form-item prop="code_comarch" label="Code Comarch">
                    <el-input v-model="modal.createEditCategory.form.code_comarch"></el-input>
                </el-form-item>
                <el-form-item prop="name_comarch" label="Name Comarch">
                    <el-input v-model="modal.createEditCategory.form.name_comarch"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.createEditCategory.display = false">Annuler</el-button>
                <el-button type="primary" @click="updateCategory">Enregistrer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import Category from '../../models/Category';
import { filterCascader } from '../filters';
export default {
    data() {
        return {
            categoriesOptions: [],
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            modalGalery: {
                display: false,
                category: {},
                selected: [],
                loader: false
            },
            modalVariations: {
                display: false,
                category: {}
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Veuillez renseignez un nom',
                        trigger: 'blur'
                    }
                ],
                categories: [
                    {
                        required: true,
                        message: 'Veuillez choisir une catégorie parente',
                        trigger: 'blur'
                    },
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un ShopId',
                        trigger: 'blur'
                    },
                ],
            },
            modal: {
                display: false,
                category: {},
                createEditCategory: {
                    display: false,
                    loader: false,
                    form: {
                        categories: [],
                        activated: true
                    }
                }
            }
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['categories/totalItems'];
        },
        categories() {
            return this.$store.getters['categories/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        appendSearch() {
            return this.params['product_search'] ? ' '+this.params['product_search']+'&scope=name' : ''
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
         axios.get('/categories').then(r => {
            this.categoriesOptions = r.data.data;
        });
        this.$store.dispatch('app/setSearchMode', 'categories');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    case 'product_search':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    default:
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        removeCategory(category)
        {
            this.$confirm('Ceci effacera la catégorie. Continuer?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.delete('/categories/'+category.id).then(()=>{
                    this.fetch()
                    this.$message({
                        type: 'success',
                        message: 'Categorie supprimé'
                    });
                }).catch(()=>{

                })

            }).catch(() => {

            });
        },
        updateCategory()
        {
            this.$refs.formCreateEditCategory.validate((valid, errors) => {
                if (valid) {
                    var catId = this.modal.createEditCategory.form.categories[
                        this.modal.createEditCategory.form.categories.length - 1
                    ];
                    this.modal.createEditCategory.form.parent_id = catId;
                    if( this.modal.createEditCategory.form.id ) {
                        axios
                        .post('/categories/' + this.modal.createEditCategory.form.id, this.modal.createEditCategory.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Catgorie mise à jour.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    } else {
                        axios
                        .post('/categories', this.modal.createEditCategory.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Catgorie créer.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    }

                }
            })
        },
        openEdit( category )
        {
            if( !category ) {
                category = new Category
            }
            this.modal.createEditCategory.form = category.toDatas();
            this.modal.createEditCategory.display = true;
        },
        closeEdit()
        {
            this.modal.createEditCategory.form = { categories: [], activated: true };
            this.modal.createEditCategory.display = false;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('categories/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('categories/fetch', params).then(() => {
                this.loading = false;
            });
        },

        updateCategoryInList(id, data) {
            this.$store.dispatch('categories/updateInList', { id, data });
        },

        deleteCategoryInList(id) {
            this.$store.dispatch('categories/removeInList', id);
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(category) {
            this.modal.display = true;
            this.modal.category = category.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        onUpdateCategory(category) {
            this.updateCategoryInList(category.id, category);
            this.$refs.filtersComponent.validFilters();
            this.closeModalEdit();
        },

        updateCategories(categories) {
            this.$refs.multipleTable.clearSelection();
            categories.forEach(category => {
                this.updateCategoryInList(category.id, category);
            });
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.categories .category-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        onDeleteCategory(id) {
            this.deleteCategoryInList(id);
            this.closeModalEdit();
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        },
        filterCascader(node, keyword)
        {
            return filterCascader(node, keyword)
        }
    }
};
</script>
<style lang="scss">
.categories {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}

</style>
